import { colors } from '@styles/vars/colors.style'
import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'

export const CaseStudyMain = styled.div`
    position: relative;
    a {
        text-decoration: none;
        width: 100%;
        &:before {
            position: absolute;
            content: "";
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 1;
        }
    }
    &.grid {
        margin-bottom: 30px;
        
        &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            background: rgba(0,0,0,0.5);
            height: 100%;
            width: 100%;
            opacity: 0;
            transition: all 0.25s ease;
        }
        .caseStudyContainer {
            width: 100%;
            aspect-ratio: 1/1;
        }
        .content {
            padding: 40px 30px 40px 40px;
            opacity: 0;
            color: ${colors.white};
            justify-content: flex-end;
            display: flex;
            flex-flow: column;
        }
        &:hover {
            &:after {
                opacity: 1;
            }
            .content {
                opacity: 1;
            }
        }
        .caseStudyImage {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .gatsby-image-wrapper {
            position: absolute;
            height: 100% !important;
            min-width: 100%;
        }
    }
    &.list {
        &:hover {
            .gatsby-image-wrapper {
                height: 360px !important;
            }
            .content {
                ${mq.tabletP} {
                    transform: translateX(20px);
                }
            }
        }
        .content {
            ${mq.tabletL} {
                padding: 40px 30px 40px 0;
            }
            width: 60%;
            ${mq.tabletPMax} {
                width: 100%;
            }
        }
        .caseStudyContainer {
            display: flex;
            align-items: center;
            border-bottom:1px solid ${colors.mist};
        }
        
        .caseStudyImage {
            width: 25%;
            aspect-ratio: 1/1;
            max-width: 360px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            margin: -8% 0;
            ${mq.tabletPMax} {
                display: none;
            }
        }
        .gatsby-image-wrapper {
            position: absolute;
            transition: height 0.25s ease;
            height: 0 !important;
            max-height: 100%;
        }
    }
    .arrowIcon {
        width: 40px;
    }
    
`

export const IconContainer = styled.div`
    width: 24px;
    margin: auto 20px 40px auto;
    ${mq.tabletPMax} {
        width: 16px;
        margin: auto 20px 30px auto;
    }
`

export const CaseStudyImage = styled.div`
`

export const CaseStudyContent = styled.div`
    position: relative;
    z-index: 1;
    height: 100%;
    
    ${mq.tabletPMax} {
        padding: 25px 15px;
    }
    p {
        line-height: 30px;
    }
    transition: all 0.25s ease;
    .title {
        margin-top: 10px;
        strong {
            font-weight: normal;
            font-family: Signifier;
        }
        ${mq.tabletPMax} {
            br {
                display: none;
            }
            h4{
                font-size: 14px;
            }
        }
    }
`

export const CaseStudyContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-end;
    position: relative;
`